// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"286d477d","541":"b6a18b86"}[chunkId] + ".chunk.js";
};